// Note: This is copy+paste from embla implementation. Importing NotificationModule from embla throws compile error on jQuery

import * as toastr from 'toastr';

export default class NotificationModule {

    static showNeutral(title: string, message: string, autohide?: boolean) {

        if (autohide === undefined) {
            autohide = true;
        }

        this.setOptions(autohide);
        this.setNeutral();

        toastr.info(message, title, {
            iconClass: ' '
        });
    }

    static showNeutralSmall(message: string, autohide?: boolean) {

        if (autohide === undefined) {
            autohide = true;
        }

        this.setOptions(autohide);
        this.setNeutral();
        this.setSmall();

        toastr.info(message, '', {
            iconClass: ' '
        });
    }

    static showSuccessSmall(message: string, autohide?: boolean) {

        if (autohide === undefined) {
            autohide = true;
        }

        this.setOptions(autohide);
        this.setSmall();
        toastr.success(message);
    }

    static showInfoSmall(message: string, autohide?: boolean) {

        if (autohide === undefined) {
            autohide = true;
        }

        this.setOptions(autohide);
        this.setSmall();
        toastr.info(message);
    }

    static showErrorSmall(message: string, autohide?: boolean) {

        if (autohide === undefined) {
            autohide = false;
        }

        this.setOptions(autohide);
        this.setSmall();
        toastr.error(message);
    }

    static showSuccess(title: string, message: string, autohide?: boolean) {

        if (autohide === undefined) {
            autohide = true;
        }

        this.setOptions(autohide);
        toastr.success(message, title);
    }

    static showInfo(title: string, message: string, autohide?: boolean) {

        if (autohide === undefined) {
            autohide = true;
        }

        this.setOptions(autohide);
        toastr.info(message, title);
    }

    static showError(title: string, message: string, autohide?: boolean) {

        if (autohide === undefined) {
            autohide = false;
        }

        this.setOptions(autohide);
        toastr.error(message, title);
    }

    static setOptions(autoHide?: boolean) {

        if (autoHide === undefined) {
            autoHide = true;
        }
        
        toastr.options.onShown = undefined;
        toastr.options.positionClass = 'notification-container';
        toastr.options.progressBar = false;
        toastr.options.closeButton = true;        
        toastr.options.newestOnTop = false;
        toastr.options.toastClass = 'toast';

        if (autoHide === false) {
            toastr.options.timeOut = 0;
            toastr.options.extendedTimeOut = 5000;
        } else {
            toastr.options.timeOut = 7000;
            toastr.options.extendedTimeOut = 5000;
        }
    }

    static setSmall() {
        toastr.options.toastClass += ' notification-small';
    }

    static setNeutral() {
        toastr.options.toastClass += ' notification-neutral';
    }

    static clear() {
        toastr.clear();
    }
}


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/uiComponents/layout/Notification.tsx